/* External */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/* Storage */
import { selectAllChannels } from '../storage/channels';

export default function useSportsChannels(category) {
  const allChannels = useSelector(selectAllChannels);

  return useMemo(
    () => allChannels.filter((channel) => channel.categories?.some(
      (c) => c.toLowerCase() === category.toLowerCase(),
    )),
    [allChannels, category],
  );
}
